import DesktopShell from '@/karehero-app/shell/DesktopShell';
import ChatV2 from '@/karehero-app/tell-us-once/intake/ChatV2';
import {
  INTAKE_CHAT_V2,
  intakeStep,
} from '@/karehero-app/tell-us-once/intake/content';

// The same conversation on a desktop. One screen, to see whether the flow
// survives leaving the phone.
//
// The bar and the centred column are DesktopShell's — the pattern this screen
// established and every desktop-width screen now shares. Nothing about the
// conversation itself changes, which is the point of showing it: if the pattern
// needs different behaviour on a desktop, that is a finding.
const ChatDesktop = () => (
  <DesktopShell>
    <ChatV2
      questions={INTAKE_CHAT_V2}
      startAt={intakeStep('anything-else')}
      sent={2}
      desktop
      onExit={() => {}}
    />
  </DesktopShell>
);

export default ChatDesktop;
